import React from 'react';
import { Step } from 'components/SteppedModal';
import { socialShareModalFooterBlock as block } from '../utils';
import ScheduleButton from './ScheduleButton';
import ShareButton from './ShareButton';

export type UseSocialShareModalFooterConfig = {
  disableFooterButtons?: boolean;
  onShare?: () => void;
};

export type UseSocialShareModalFooterResult = Pick<
  Step,
  'footerClassName' | 'fluidFooterButtons' | 'renderFooterButtons'
>;

export default function useSocialShareModalFooter({
  disableFooterButtons,
  onShare,
}: UseSocialShareModalFooterConfig): UseSocialShareModalFooterResult {
  return {
    footerClassName: block(),
    fluidFooterButtons: true,
    renderFooterButtons: () => [
      <ScheduleButton key="schedule" isDisabled={disableFooterButtons} />,
      <ShareButton
        key="share"
        onShare={onShare}
        isDisabled={disableFooterButtons}
      />,
    ],
  };
}
